import Bonus from './Bonus';

export default class Shield extends Bonus {
  constructor({ game, player, values, road }) {
    super({
      game,
      player,
      values,
      road,
      name: 'shield',
    });
    this._chance = 0.002;
  }
  _take() {
    super._take();
    this._player.activateAnimation('shieldCreate');
  }
}



// WEBPACK FOOTER //
// ./src/js/Shield.js